import API from '@/shared/plugins/Api/API'

class LIFECYCLE extends API {
  constructor (id) {
    super(id, true)
  }

  async maintenance () {
    return this.request({
      method: 'GET',
      url: 'status/maintenance',
      retries: 1,
      retriesDelay: 2000
    })
  }
}

export default LIFECYCLE
